module.exports = __webpack_public_path__ + "ce77f36df6503d014cae1242748d294b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.png
// module id = 2010
// module chunks = 0